__turbopack_context__.v({
  "badge": "page-module-scss-module__Ex3ana__badge",
  "badge_always": "page-module-scss-module__Ex3ana__badge_always",
  "badge_category": "page-module-scss-module__Ex3ana__badge_category",
  "badge_live": "page-module-scss-module__Ex3ana__badge_live",
  "badge_recruiting": "page-module-scss-module__Ex3ana__badge_recruiting",
  "badge_small": "page-module-scss-module__Ex3ana__badge_small",
  "badge_soon": "page-module-scss-module__Ex3ana__badge_soon",
  "card": "page-module-scss-module__Ex3ana__card",
  "card_body": "page-module-scss-module__Ex3ana__card_body",
  "card_grid": "page-module-scss-module__Ex3ana__card_grid",
  "card_link": "page-module-scss-module__Ex3ana__card_link",
  "card_memo": "page-module-scss-module__Ex3ana__card_memo",
  "card_meta": "page-module-scss-module__Ex3ana__card_meta",
  "card_status_wrap": "page-module-scss-module__Ex3ana__card_status_wrap",
  "card_thumb": "page-module-scss-module__Ex3ana__card_thumb",
  "card_title": "page-module-scss-module__Ex3ana__card_title",
  "empty_message": "page-module-scss-module__Ex3ana__empty_message",
  "inner": "page-module-scss-module__Ex3ana__inner",
  "pending": "page-module-scss-module__Ex3ana__pending",
  "slide": "page-module-scss-module__Ex3ana__slide",
  "slide_controls": "page-module-scss-module__Ex3ana__slide_controls",
  "slide_dots": "page-module-scss-module__Ex3ana__slide_dots",
  "slide_inner": "page-module-scss-module__Ex3ana__slide_inner",
  "slide_inner_color_black": "page-module-scss-module__Ex3ana__slide_inner_color_black",
  "slide_item": "page-module-scss-module__Ex3ana__slide_item",
  "slide_memo": "page-module-scss-module__Ex3ana__slide_memo",
  "slide_meta": "page-module-scss-module__Ex3ana__slide_meta",
  "slide_next": "page-module-scss-module__Ex3ana__slide_next",
  "slide_prev": "page-module-scss-module__Ex3ana__slide_prev",
  "slide_title": "page-module-scss-module__Ex3ana__slide_title",
  "slide_wrap": "page-module-scss-module__Ex3ana__slide_wrap",
  "status_badges": "page-module-scss-module__Ex3ana__status_badges",
  "tab_button": "page-module-scss-module__Ex3ana__tab_button",
  "tab_list": "page-module-scss-module__Ex3ana__tab_list",
  "tab_wrap": "page-module-scss-module__Ex3ana__tab_wrap",
  "wrapper": "page-module-scss-module__Ex3ana__wrapper",
});
